import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getAuthHeaders = () => {
  const lang = localStorage.getItem("lang") || "en";

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Accept-Language": lang,
  };
};

export const getSalesReport = async (params = {}) => {
  try {
    const response = await api.get(`${API_BASE_URL}api/sales-report/list`, {
      params,
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Get Sales Report API Error:", error);
    throw error?.response?.data || { message: "Failed to fetch sales report" };
  }
};